import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const ArrowLeftIcon = props => (
  <SvgIcon {...props}>
    <g>
      <path d="M18.24,23.88,5.1,12.38a.51.51,0,0,1,0-.76L18.24.12l.66.76L6.19,12,18.9,23.12Z" />
    </g>
  </SvgIcon>
);

export default ArrowLeftIcon;
